"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _reactRedux = require("react-redux");

var _get = _interopRequireDefault(require("transmute/get"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _LegalConsentInputs = _interopRequireDefault(require("MeetingsLib/components/input/LegalConsentInputs"));

var _StepButtonsFooter = _interopRequireDefault(require("MeetingsLib/components/page/StepButtonsFooter"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _LegalConsentOptions = _interopRequireDefault(require("MeetingsBase/models/LegalConsentOptions"));

var _LegalConsentFormSelectors = require("MeetingsLib/selectors/LegalConsentFormSelectors");

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var FormActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/FormActions"));

var _HiddenAriaStatus = require("MeetingsLib/components/decorative/HiddenAriaStatus");

var LegalConsentForm = (0, _createReactClass.default)({
  displayName: "LegalConsentForm",
  propTypes: {
    // passed
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    submittingMeeting: _propTypes.default.bool,
    goToPreviousStep: _propTypes.default.func.isRequired,
    // loaded
    legalConsentOptions: _propTypes.default.instanceOf(_LegalConsentOptions.default).isRequired,
    stagedLegalConsentResponses: _propTypes.default.instanceOf(_immutable.List),
    setGivenConsent: _propTypes.default.func.isRequired,
    resetConsentResponses: _propTypes.default.func.isRequired,
    submitConsentResponses: _propTypes.default.func.isRequired,
    allRequiredConsentCollected: _propTypes.default.bool.isRequired,
    offline: _propTypes.default.bool,
    isLegitimateInterest: _propTypes.default.bool.isRequired,
    dateTime: _propTypes.default.number.isRequired,
    userTimezone: _propTypes.default.string.isRequired
  },
  handleGoBack: function handleGoBack() {
    var _this$props = this.props,
        resetConsentResponses = _this$props.resetConsentResponses,
        goToPreviousStep = _this$props.goToPreviousStep;
    resetConsentResponses();
    goToPreviousStep();
  },
  handleSubmit: function handleSubmit() {
    var _this$props2 = this.props,
        stagedLegalConsentResponses = _this$props2.stagedLegalConsentResponses,
        submitConsentResponses = _this$props2.submitConsentResponses;
    submitConsentResponses(stagedLegalConsentResponses);
  },
  renderAccessibleMessage: function renderAccessibleMessage() {
    var _this$props3 = this.props,
        companyName = _this$props3.branding.companyName,
        dateTime = _this$props3.dateTime,
        userTimezone = _this$props3.userTimezone;

    var selectedDate = _I18n.default.moment(dateTime).tz(userTimezone).format('LLLL');

    var accessibleMessage = _react.default.createElement(_FormattedMessage.default, {
      message: "accessible.privacyStatusNoCompany",
      options: {
        selectedDate: selectedDate
      }
    });

    if (companyName) {
      accessibleMessage = _react.default.createElement(_FormattedMessage.default, {
        message: "accessible.privacyStatus",
        options: {
          domain: companyName,
          selectedDate: selectedDate
        }
      });
    }

    return accessibleMessage;
  },
  renderHeader: function renderHeader() {
    return _react.default.createElement(_H.default, {
      tabIndex: 1,
      className: "p-x-1 m-bottom-5"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "dataPrivacy"
    }), _react.default.createElement(_HiddenAriaStatus.HiddenAriaStatus, {
      role: "status",
      "aria-live": "polite"
    }, this.renderAccessibleMessage()));
  },
  renderFormButtons: function renderFormButtons() {
    var _this$props4 = this.props,
        branding = _this$props4.branding,
        submittingMeeting = _this$props4.submittingMeeting,
        allRequiredConsentCollected = _this$props4.allRequiredConsentCollected,
        offline = _this$props4.offline,
        isLegitimateInterest = _this$props4.isLegitimateInterest;
    return _react.default.createElement(_StepButtonsFooter.default, {
      branding: branding,
      submittingMeeting: submittingMeeting,
      canProceed: isLegitimateInterest || allRequiredConsentCollected,
      tooltipTitle: _react.default.createElement(_FormattedMessage.default, {
        message: "buttons.tooltip.missingConsent"
      }),
      isLastStep: true,
      goToPreviousStep: this.handleGoBack,
      goToNextStep: this.handleSubmit,
      offline: offline
    });
  },
  renderLegalConsentInputs: function renderLegalConsentInputs() {
    var _this$props5 = this.props,
        legalConsentOptions = _this$props5.legalConsentOptions,
        stagedLegalConsentResponses = _this$props5.stagedLegalConsentResponses,
        setGivenConsent = _this$props5.setGivenConsent;
    return _react.default.createElement("div", {
      className: "form-body width-100 m-bottom-3 overflow-y-scroll overflow-x-hidden"
    }, _react.default.createElement(_LegalConsentInputs.default, {
      legalConsentResponses: stagedLegalConsentResponses,
      legalConsentOptions: legalConsentOptions,
      setGivenConsent: setGivenConsent
    }));
  },
  render: function render() {
    return _react.default.createElement(_UICardWrapper.default, {
      className: "height-100"
    }, _react.default.createElement(_UICardSection.default, {
      className: "height-100 p-y-6"
    }, _react.default.createElement(_UIFlex.default, {
      className: "height-100",
      direction: "column",
      justify: "around"
    }, this.renderHeader(), this.renderLegalConsentInputs(), this.renderFormButtons())));
  }
});

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    allRequiredConsentCollected: (0, _LegalConsentFormSelectors.getAllStagedRequiredConsentCollected)(state),
    legalConsentOptions: (0, _get.default)('legalConsentOptions', (0, _BookInfoSelectors.getCustomParams)(state)),
    stagedLegalConsentResponses: (0, _LegalConsentFormSelectors.getStagedLegalConsentResponses)(state),
    offline: (0, _BookInfoSelectors.getOffline)(state),
    isLegitimateInterest: (0, _BookInfoSelectors.getIsLegitimateInterest)(state),
    userTimezone: state.userTimezone
  };
}, Object.assign({}, FormActions))(LegalConsentForm);

exports.default = _default;
module.exports = exports.default;